module.exports = __webpack_public_path__ + "img/ZWF_Carlos_Fernanda.0fcf2a5f.jpg";